import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import FacetCommon from './FacetForm'

const FacetCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <FacetCommon disable={false} />
      </Create>
    </SectionWrapper>
  )
}

export default FacetCreate
